import React, { useState, useEffect } from 'react';
import ServicesSection from './ServicesSection';
import MaisMeiFeaturesSection from './MaisMeiFeaturesSection';
import ManifestoSection from './ManifestoSection';
import TestimonialsSection from './TestimonialsSection';
import FAQSection from './FAQSection';
import Footer from './Footer';
import Header from './Header';
import HeroSection from './HeroSection';
import NextStepsSection from './NextStepsSection';
import CTASection from './CTASection';
import NicheBannersSection from './NicheBannersSection';
import PromoModal from './PromoModal'; // ✅ NOVO: Import do modal promocional
import { motion, AnimatePresence } from 'framer-motion';

const CategoryIcons = {
    Contabilidade: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="4" fill="#F0F0F0"/>
        <path d="M12 7V17M7 12H17" stroke="#30514F" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    Gestão: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="4" fill="#F0F0F0"/>
        <path d="M12 8V16M9 11V16M15 13V16M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z" stroke="#30514F" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    Finanças: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="4" fill="#D9F99D"/>
        <path d="M12 8V16M9 11V16M15 13V16M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z" stroke="#30514F" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    Vendas: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="4" fill="#F0F0F0"/>
        <path d="M4 7H20M4 11H20M4 15H20M4 19H20" stroke="#30514F" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    Negócio: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="4" fill="#F0F0F0"/>
        <path d="M12 7L16.5 10.5M12 7L7.5 10.5M12 7V3M16.5 10.5L14.5 12M16.5 10.5L17 6M7.5 10.5L9.5 12M7.5 10.5L7 6M12 21C16.4183 21 20 17.4183 20 13M12 21C7.58172 21 4 17.4183 4 13M12 21V17M20 13C20 8.58172 16.4183 5 12 5C7.58172 5 4 8.58172 4 13" stroke="#30514F" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    )
  };
  
  const VerticalCarousel = () => {
    const categories = [
      { label: 'Contabilidade', icon: 'Contabilidade' },
      { label: 'Gestão', icon: 'Gestão' },
      { label: 'Finanças', icon: 'Finanças' },
      { label: 'Vendas', icon: 'Vendas' },
      { label: 'Negócio', icon: 'Negócio' }
    ];
  
    const [currentIndex, setCurrentIndex] = useState(2);
  
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % categories.length);
      }, 3000);
  
      return () => clearInterval(interval);
    }, []);
  
    return (
      <div className="relative w-full max-w-[257px] h-[200px] overflow-hidden">
        <AnimatePresence>
          {categories.map((category, index) => {
            const isActive = currentIndex === index;
            const offset = index - currentIndex;
            
            return (
              <motion.div 
                key={category.label}
                initial={{ 
                  opacity: 0, 
                  y: offset > 0 ? 100 : -100 
                }}
                animate={{ 
                  opacity: isActive ? 1 : 0.5,
                  y: 0,
                  position: 'absolute',
                  width: '100%'
                }}
                exit={{ 
                  opacity: 0, 
                  y: offset > 0 ? 100 : -100 
                }}
                transition={{ 
                  duration: 0.5 
                }}
                className={`
                  absolute left-0 right-0 py-2 px-3 rounded-lg flex items-center space-x-2
                  ${isActive ? 'bg-lime-200' : 'bg-white'}
                `}
                style={{ 
                  top: `${(index - currentIndex + 2) * 40}px`
                }}
              >
                {CategoryIcons[category.icon]}
                <span className={`${isActive ? 'text-[#30514F] font-semibold' : 'text-gray-500'}`}>
                  {category.label}
                </span>
              </motion.div>
            );
          })}
        </AnimatePresence>
      </div>
    );
  };

const LandingPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [showPromoModal, setShowPromoModal] = useState(true); // ✅ NOVO: Estado do modal

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const navigateTo = (url) => {
    window.location.href = url;
  };

  // ✅ NOVO: Handler para fechar o modal
  const handleClosePromoModal = () => {
    setShowPromoModal(false);
  };

  return (
    <div className="min-h-screen font-sans">
      {/* ✅ NOVO: Modal Promocional de Alta Conversão */}
      {showPromoModal && <PromoModal onClose={handleClosePromoModal} />}

      {/* Header */}
      <Header />

      {/* Hero Section */}
      <HeroSection handleNavigation={navigateTo} />

      {/* NOVO: Banners para nichos específicos */}
      <NicheBannersSection />

      {/* Next Steps Section */}
      <NextStepsSection />

      {/* Services Section */}
      <ServicesSection />

      {/* MaisMei Features */}
      <MaisMeiFeaturesSection />

      {/* NOVO: CTA Section Grande */}
      <CTASection />

      {/* Manifesto */}
      <ManifestoSection />

      {/* Testimonials */}
      <TestimonialsSection />

      {/* FAQ */}
      <FAQSection />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;